import React from 'react'

// 🔴 PART 15c — THE MARK IN THE BAR IS THIS SITE'S OWN FAVICON.
//
// George, 24 September 2026, verbatim: *"making sure the favicon is the same icon used in the
// header"*. Until today the bar drew the shared five-circle family glyph while the favicon was
// this site's own 3×3 grid — two different pictures for one site, which is the fault the rule
// names. The bar now draws the favicon's own drawing, so the tab, the bookmark and the header
// are ONE icon. Part 3's construction is unchanged (full width, sticky, this site's own
// near-black at 0.82 through a blur, the hairline underneath, the label over
// NODEJAVASCRIPT.COM); only the GLYPH is the site's own.
//
// It is drawn ONCE here and used TWICE — the header bar and the footer's brand line — so the two
// can never drift into two different marks.
//
// 🔴 THE GEOMETRY IS THE FAVICON'S, VERBATIM — DO NOT "TIDY" THE NUMBERS, AND DO NOT ROUND the
// grid's `26.33` / `37.67`. Part 15c is measured, by `svg_sig()` in `~/.nodejs_compliance.py`,
// from the RENDERED page: it compares this drawing with `public/favicon.svg` shape by shape — a
// circle by its centre, a rect and a path by their own commands — so a rounded coordinate, a
// rescaled rect or an added `fill` is a DIFFERENT drawing to that check. The `<g stroke>` is kept
// because the grid's rule and the path carry no stroke of their own, exactly as the favicon
// writes them; the only omission is the favicon's background plate, because the bar is already
// that kind of ground.
const Mark = ({ size = 22 }) => (
  <svg viewBox='0 0 64 64' width={size} height={size}>
    <g stroke='#a3e635' strokeWidth='2'>
      <rect x='15' y='15' width='34' height='34' rx='4' fill='none' />
      <path d='M26.33 15v34M37.67 15v34M15 26.33h34M15 37.67h34' fill='none' />
    </g>
    <rect x='17.5' y='17.5' width='6.6' height='6.6' rx='1.6' fill='#a3e635' />
    <rect x='28.8' y='28.8' width='6.6' height='6.6' rx='1.6' fill='#bef264' />
    <rect x='40.2' y='40.2' width='6.6' height='6.6' rx='1.6' fill='#84cc16' />
  </svg>
)

export default Mark
